// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCardModalHeader_root__vpI6r","closeButton":"PlasmicCardModalHeader_closeButton__irLxP"};